"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconBan = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconBan = function SvgIconBan(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 6C10.6 8.54051 8.54051 10.6 6 10.6C4.97972 10.6 4.03703 10.2678 3.27415 9.70575L9.70575 3.27415C10.2678 4.03703 10.6 4.97972 10.6 6ZM2.28574 8.71426L8.71426 2.28574C7.95344 1.72881 7.01512 1.4 6 1.4C3.45949 1.4 1.4 3.45949 1.4 6C1.4 7.01512 1.72881 7.95344 2.28574 8.71426ZM12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z",
    fill: "currentColor"
  }));
};

exports.SvgIconBan = SvgIconBan;